module.exports = __webpack_public_path__ + "img/music_closed.e91318f4.png";